var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-4" },
    [
      _c(
        "b-button",
        {
          directives: [
            {
              name: "b-modal",
              rawName: "v-b-modal",
              value: "modal-action-" + _vm.action,
              expression: "`modal-action-${action}`"
            },
            {
              name: "ripple",
              rawName: "v-ripple.400",
              value: "rgba(113, 102, 240, 0.15)",
              expression: "'rgba(113, 102, 240, 0.15)'",
              modifiers: { "400": true }
            }
          ],
          attrs: { variant: _vm.color, block: "" },
          on: {
            click: function($event) {
              return _vm.$emit("set-action", _vm.action)
            }
          }
        },
        [_vm._v(" " + _vm._s(_vm.title) + " ")]
      ),
      _vm.commentModal.includes(_vm.action)
        ? _c("ModalComment", {
            attrs: {
              newFlow: _vm.newFlow,
              action: _vm.action,
              title: _vm.title,
              "step-id": _vm.stepId
            }
          })
        : _vm._e(),
      _vm.editModal.includes(_vm.action)
        ? _c("ModalEdition", {
            attrs: {
              action: _vm.action,
              title: _vm.title,
              "step-id": _vm.stepId,
              attachment: _vm.attachment
            }
          })
        : _vm._e(),
      _vm.resendModal.includes(_vm.action)
        ? _c("ModalResend", {
            attrs: {
              action: _vm.action,
              title: _vm.title,
              "step-id": _vm.stepId,
              "is-signer": _vm.isSigner,
              "has-signature-positon": _vm.hasSignaturePosition
            }
          })
        : _vm._e(),
      _vm.signModal.includes(_vm.action)
        ? _c("ModalSign", {
            attrs: {
              newFlow: _vm.newFlow,
              action: _vm.action,
              title: _vm.title,
              "step-id": _vm.stepId,
              "get-sign": _vm.getSign
            },
            on: {
              selectedSign: function($event) {
                return _vm.$emit("selectedSign", $event)
              }
            }
          })
        : _vm._e(),
      _vm.signAttachmentModal.includes(_vm.action)
        ? _c("ModalSignAttachment", {
            attrs: {
              action: _vm.action,
              title: _vm.title,
              attachment: _vm.attachment,
              "step-id": _vm.stepId,
              "get-sign": _vm.getSign
            }
          })
        : _vm._e(),
      _vm.officeModal.includes(_vm.action)
        ? _c("ModalOffice", {
            attrs: {
              process: _vm.process,
              action: _vm.action,
              title: _vm.title,
              "step-id": _vm.stepId,
              "get-sign": _vm.getSign
            }
          })
        : _vm._e(),
      _vm.manageDateModal.includes(_vm.action)
        ? _c("ModalManageDate", {
            attrs: {
              process: _vm.process,
              action: _vm.action,
              title: _vm.title,
              "step-id": _vm.stepId,
              "get-sign": _vm.getSign
            }
          })
        : _vm._e(),
      _vm.configureSignModal.includes(_vm.action)
        ? _c("ModalConfigureSign", {
            attrs: {
              process: _vm.process,
              action: _vm.action,
              title: _vm.title,
              "step-id": _vm.stepId,
              "get-sign": _vm.getSign
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }